module.exports = __webpack_public_path__ + "static/media/link-visa.4925a6d1.svg";